import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Observable } from 'rxjs';
import { CovanceFilter } from '../../covance-filter';
import { TabCategory } from '../../documents';
import { map, refCount, publishReplay } from 'rxjs/operators';
import { UrlBuilder } from '../../core';
import { SponsorRouteData } from '../sponsor-route-data';

@Component({
    selector: 'sponsor-kit-inventory',
    template: require('./sponsor-kit-inventory.component.html'),
    styles: [require('./sponsor-kit-inventory.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SponsorKitInventoryComponent {

    public tabs: TabCategory[];

    constructor(
        private urlBuilder: UrlBuilder,
        private sponsorRouteData: SponsorRouteData,
    ) {
        const inventorySummaryUrl = this.urlBuilder
            .esa()
            .sponsor()
            .study(this.sponsorRouteData.snapshot.selectedStudy)
            .kitInventory()
            .inventorySummary()
            .url();
        const expirationUrl = this.urlBuilder
            .esa()
            .sponsor()
            .study(this.sponsorRouteData.snapshot.selectedStudy)
            .kitInventory()
            .expiration()
            .url();

        this.tabs = [{ name: 'Inventory Summary Report', url: inventorySummaryUrl }, { name: 'On Hand Inventory with Expiration Dates Report', url: expirationUrl }];
    }

}